import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        recipes: 'Recipes',
        createNewRecipe: 'Create new recipe',
        createRecipe: 'Create recipe',
        title: 'Title',
        weight: 'Standard weight in grams',
        ingredients: 'Ingredients',
        ingredient: 'Ingredient',
        ingredientColon: 'Ingredient:',
        percentage: 'Percentage',
        percentageColon: 'Percentage:',
        addIngredient: 'Add ingredient',
        submit: 'Submit',
        editRecipe: 'Edit recipe',
        deleteRecipe: 'Delete recipe',
        weightInGrams: 'Weight in grams',
        en: 'EN',
        da: 'DA'
      }
    },
    da: {
      translation: {
        recipes: 'Opskrifter',
        createNewRecipe: 'Opret ny opskrift',
        createRecipe: 'Opret opskrift',
        title: 'Titel',
        weight: 'Standardvægt i gram',
        ingredients: 'Ingredienser',
        ingredient: 'Ingrediens',
        ingredientColon: 'Ingrediens:',
        percentage: 'Procent',
        percentageColon: 'Procent:',
        addIngredient: 'Tilføj ingrediens',
        submit: 'Submit',
        editRecipe: 'Rediger opskrift',
        deleteRecipe: 'Slet opskrift',
        weightInGrams: 'Vægt i gram',
        en: 'EN',
        da: 'DA'
      }
    }
  },
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});
